import React from 'react';

const ClearButton = (props: {
    onClick(): void;
    additionalClickEvent?(e: React.MouseEvent): void;
}) => (
    <button
        type="button"
        className="icon icon--clear txt-quaternary clear-input is-visible"
        onClick={(e) => {
            props.onClick();
            props.additionalClickEvent?.(e);
        }}
        onMouseDown={(e) => e.preventDefault()}
    />
);

export default ClearButton;

export function useHandleClearButton(
    type: string,
    cb?: {
        onBlurCb?: (value: string | undefined) => void;
    }
) {
    const inputRef = React.useRef<HTMLInputElement>(null);

    const [showClear, setShowClear] = React.useState(false);

    React.useEffect(() => {
        const datalistArrow = document.querySelector(
            'input#post-ad_contactEmail'
        ) as HTMLInputElement | null;

        const inputEl = inputRef.current;
        const parentEl = inputEl?.parentElement;
        const mouseEnterCb = () =>
            inputRef.current?.value && !inputRef.current?.disabled && setShowClear(true);
        const mouseLeaveCb = () =>
            inputRef.current?.value && !inputRef.current?.disabled && setShowClear(false);
        const blurCb = () => {
            !inputRef.current?.disabled && setShowClear(false);
            cb?.onBlurCb?.(inputRef.current?.value);
        };
        const changeCb = (e: Event) => {
            const value = (e.currentTarget as HTMLInputElement).value;
            setShowClear(!inputEl?.disabled && !!value);
            if (type === 'email') {
                datalistArrow?.classList.remove('is-empty');
            }
        };

        if (inputEl && parentEl) {
            parentEl.addEventListener('mouseenter', mouseEnterCb);
            parentEl.addEventListener('mouseleave', mouseLeaveCb);
            inputEl.addEventListener('blur', blurCb);
            inputEl.addEventListener('input', changeCb);
            return () => {
                parentEl.removeEventListener('mouseenter', mouseEnterCb);
                parentEl.removeEventListener('mouseleave', mouseLeaveCb);
                inputEl.removeEventListener('blur', blurCb);
                inputEl.removeEventListener('input', changeCb);
            };
        } else {
            return;
        }
    }, [inputRef.current]);

    function onClickClear() {
        if (inputRef.current && !inputRef.current.disabled) {
            setShowClear(false);
            // 🚧 sadly undo (Cmd/Ctrl+Z) doesn't work after clear
            inputRef.current.value = '';
            const datalistArrow = document.querySelector(
                'input#post-ad_contactEmail'
            ) as HTMLInputElement | null;
            if (type === 'email' && datalistArrow) {
                datalistArrow.classList.add('is-empty');
            }
        }
    }

    return {
        inputRef,
        showClear,
        /** Usage: `<ClearButton onClick={onClickClear}>` */
        onClickClear,
    };
}
